const header = document.querySelector('.header');

document.addEventListener('DOMContentLoaded', () => {
    if (!header) return;

    document.body.style.marginTop = header.clientHeight + 'px';

    window.addEventListener('resize', () => {
        const nav = document.getElementById('navbar-default');

        if (nav.classList.contains('hidden')) {
            const header = document.querySelector('.header');

            document.body.style.marginTop = header.clientHeight + 'px';
        }
    });

    const headerTop = document.querySelector('.header__top');
    const navMenuButton = document.getElementById('nav-menu-toggle');

    navMenuButton.addEventListener('click', () => {
        document.body.classList.toggle('overflow-y-hidden'); 

        const nav = document.getElementById('navbar-default');

        if (nav.classList.contains('hidden')) {
            const header = document.querySelector('.header');

            document.body.style.marginTop = header.clientHeight + 'px';
        }
    });

    document.addEventListener('scroll', (event) => {
        if (window.innerWidth >= 768) {
            if (window.pageYOffset > 600) {
                if (!headerTop.classList.contains('hidden')) {
                    headerTop.classList.add('hidden');
                } 
            } else {
                if (headerTop.classList.contains('hidden')) {
                    headerTop.classList.remove('hidden');
                } 
            }
        }
    });

    // const headerButtons = document.querySelectorAll('.megamenu-button');

    // for (const button of headerButtons) {
    //     const type = button.getAttribute('data-collapse-toggle');

    //     button.addEventListener('click', (e) => {
    //         e.preventDefault();

    //         const megaMenus = document.querySelectorAll('.megamenu');

    //         Array.from(megaMenus).forEach(menu => {
    //             if (menu.id === type) return;

    //             menu.classList.add('hidden');
    //         });
    //     })
    // }
});